import React from 'react'
import styles from './Input.module.scss'

export const InputTitle: React.FC<React.HTMLProps<HTMLDivElement>> = ({children}) => {
  if(children == null) return null;
  return <div className={styles.title}>{children}</div>
}